// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"7d67248ea73d4ad6f1b8","655":"a5a1d8b6f354ae816ca4"}[chunkId] + ".js";
};